import { useState } from "react";
import { AiOutlineDoubleRight } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import Banner1 from '../../images/No-Image-Placeholder.png'
import { insertSelectedCategory } from "../../reducers/categories";
import { getPreviewUrl } from "../../utils/common";

const MegaMenu = ({ onClose, height = "max-h-[50vh]", addPy = "mt-4", onSelect }) => {
  const dispatch = useDispatch();
  const categoryListApi = useSelector((state) => state.categories.categoryList);
  const [activeMenu, setActiveMenu] = useState({
    masterId: null,
    categoryId: null,
    subCategoryId: null,
  });

  const selectCategory = (category, productType = null) => {
    if (category) {
      dispatch(insertSelectedCategory(category));
      setActiveMenu({ masterId: null, categoryId: null, subCategoryId: null });
      onClose();
      if (onSelect) {
        onSelect({ categorySelected: category, selectedProductType: productType });
      }
    }
  };

  const resetActiveMenu = () => {
    setActiveMenu({ masterId: null, categoryId: null, subCategoryId: null });
  };

  const setActiveMaster = (masterId) => {
    setActiveMenu((current) => {
      if (current.masterId === masterId && current.categoryId === null && current.subCategoryId === null) {
        return current;
      }

      return { masterId, categoryId: null, subCategoryId: null };
    });
  };

  const setActiveCategory = (masterId, categoryId) => {
    setActiveMenu((current) => {
      if (current.masterId === masterId && current.categoryId === categoryId && current.subCategoryId === null) {
        return current;
      }

      return { masterId, categoryId, subCategoryId: null };
    });
  };

  const setActiveSubCategory = (masterId, categoryId, subCategoryId) => {
    setActiveMenu((current) => {
      if (
        current.masterId === masterId
        && current.categoryId === categoryId
        && current.subCategoryId === subCategoryId
      ) {
        return current;
      }

      return { masterId, categoryId, subCategoryId };
    });
  };

  const submenuClassess = `w-full absolute h-full left-full top-0`;
  const submenuItemClassess = "hover:bg-grey-200 bg-white px-2 py-2 border-b-1 cursor-pointer flex justify-between items-center";

  return (
    <div className={`w-full ${height} mega-menu-wrap overflow-y-auto ${addPy} bg-white`} onMouseLeave={resetActiveMenu}>
      {categoryListApi?.map((masterCat, index) => (
        (() => {
          const isMasterActive = activeMenu.masterId === masterCat._id;

          return (
            <div
              key={index}
              className={`px-2 py-2 border-b-1 cursor-pointer flex justify-between items-center mega-menu-master ${isMasterActive ? "bg-grey-200" : "hover:bg-grey-200"}`}
              onMouseEnter={() => setActiveMaster(masterCat._id)}
            >
              <SubMenuItem
                onClick={() => {
                  let _category = { id: masterCat._id, name: masterCat.name, categories: null };
                  selectCategory(_category, null);
                }}
                cat={masterCat}
                hasSubMenu={(masterCat.categories.length > 0 || masterCat.productTypes?.length > 0)}
              />
              {masterCat.categories.length > 0 && isMasterActive && (
                <div className={`${submenuClassess} mega-menu-cat`}>
                  {masterCat.categories.map((category, catIndex) => {
                    const isCategoryActive = activeMenu.categoryId === category._id;

                    return (
                      <div
                        key={catIndex}
                        className={`${submenuItemClassess} ${isCategoryActive ? "bg-grey-200" : ""}`.trim()}
                        onMouseEnter={() => setActiveCategory(masterCat._id, category._id)}
                      >
                        <SubMenuItem
                          onClick={() => {
                            let _categorylv1 = { id: masterCat._id, name: masterCat.name, categories: { id: category._id, name: category.name, "sub-categories": null, }, };
                            selectCategory(_categorylv1, null);
                          }}
                          cat={category}
                          hasSubMenu={(category["sub-categories"].length > 0 || category.productTypes?.length > 0)}
                        />

                        {category?.["sub-categories"].length > 0 && isCategoryActive && (
                          <div className={`${submenuClassess} mega-menu-sub`} >
                            {category?.["sub-categories"].map((subCategory, subCatIndex) => {
                              const isSubCategoryActive = activeMenu.subCategoryId === subCategory._id;

                              return (
                                <div
                                  key={subCatIndex}
                                  className={`${submenuItemClassess} ${isSubCategoryActive ? "bg-grey-200" : ""}`.trim()}
                                  onMouseEnter={() => setActiveSubCategory(masterCat._id, category._id, subCategory._id)}
                                >
                                  <SubMenuItem
                                    onClick={() => {
                                      let _categorylv2 = { id: masterCat._id, name: masterCat.name, categories: { id: category._id, name: category.name, "sub-categories": { id: subCategory._id, name: subCategory.name, "product-type": null }, }, };
                                      selectCategory(_categorylv2, null);
                                    }}
                                    cat={subCategory}
                                    hasSubMenu={subCategory["productTypes"]?.length > 0}
                                  />

                                  {isSubCategoryActive && (
                                    <ProductGrid
                                      data={subCategory?.productTypes}
                                      onClick={(cat) => {
                                        const _category = { id: masterCat._id, name: masterCat.name, categories: { id: category._id, name: category.name, "sub-categories": { id: subCategory._id, name: subCategory.name, "product-type": { id: cat._id, name: cat.name } }, }, };
                                        selectCategory(_category, cat._id);
                                      }}
                                    />
                                  )}
                                </div>
                              );
                            })}

                            <ProductGrid
                              data={category?.["sub-categories"]?.productTypes}
                              onClick={(cat) => {
                                const _category = { id: masterCat._id, name: masterCat.name, categories: { id: category._id, name: category.name, "sub-categories": { "product-type": { id: cat._id, name: cat.name } }, }, };
                                selectCategory(_category, cat._id);
                              }}
                            />
                          </div>
                        )}

                        {isCategoryActive && (
                          <ProductGrid
                            data={category?.productTypes}
                            onClick={(cat) => {
                              const _category = { id: masterCat._id, name: masterCat.name, categories: { id: category._id, name: category.name, "sub-categories": { "product-type": { id: cat._id, name: cat.name } }, }, };
                              selectCategory(_category, cat._id);
                            }}
                          />
                        )}
                      </div>
                    );
                  })}
                </div>
              )}

              {isMasterActive && (
                <ProductGrid
                  data={masterCat.productTypes}
                  onClick={(cat) => {
                    const _category = { id: masterCat._id, name: masterCat.name, categories: { "sub-categories": { "product-type": { id: cat._id, name: cat.name } }, }, };
                    selectCategory(_category, cat._id);
                  }}
                />
              )}
            </div>
          );
        })()
      ))}
    </div>
  );
};

const ProductGrid = ({ data = [], onMouseEnter, onClick }) => {
  return (
    <>
      {data?.length > 0 ?
        <div className={`w-[500px] mega-menu-sub-sub absolute h-full left-full top-0`} style={{ width: "500px" }}>
          <div className="p-5 bg-white border-1">
            <div className="grid grid-cols-4 gap-3">
              {data?.map((cat, index) => (
                <div key={index} className="w-full flex flex-col justify-start items-center cursor-pointer rounded-md" onClick={() => onClick(cat)}>
                  {cat.isImage ?
                    <img alt="lvl2" src={getPreviewUrl(cat.image)} className="rounded-md w-48 max-w-[100px] aspect-square object-cover" />
                    :
                    <img alt="lvl2" src={Banner1.src} className="rounded-md w-48 max-w-[100px] aspect-square object-cover" />
                  }
                  <p className="text-center px-2 mt-3 text-sm sm:text-base">{cat.name}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
        :
        null
      }
    </>
  )
}

const SubMenuItem = ({ onMouseEnter, onClick, cat, hasSubMenu }) => {
  return (
    <>
      <p className="w-full text-sm sm:text-base" onMouseEnter={onMouseEnter} onClick={onClick} >
        {cat.name}
      </p>
      {hasSubMenu && <AiOutlineDoubleRight size={12} className="ms-2" />}
    </>
  )
}
export default MegaMenu;
